// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"f2125beb","500":"d68ffa32","952":"3756a7d4"}[chunkId] + ".chunk.js";
};